import { bbox, point } from "@turf/turf"

import { POINT_MIN_BBOX_WIDTH } from "@l2r-front/l2r-map"

export function formatToBoundingBox(longitude, latitude) {
    const [minLng, minLat, maxLng, maxLat] = bbox(point([longitude, latitude]))

    const lngOffset =
        Math.max(POINT_MIN_BBOX_WIDTH - (maxLng - minLng), 0) / 2

    return ({
        minLng: minLng - lngOffset,
        minLat,
        maxLng: maxLng + lngOffset,
        maxLat,
    })
}